import type { AdminAuctionSale, AuctionSaleStatus } from '@nucleus-commerce/api-client/admin';

export const SALE_TABS = ['live', 'scheduled', 'draft', 'ended', 'cancelled'] as const;
export type SaleTab = (typeof SALE_TABS)[number];

export const QUESTION_TABS = ['pending', 'answered', 'hidden'] as const;
export type QuestionTab = (typeof QUESTION_TABS)[number];

/** The backend's bounds: seconds between closes, a minute to 30 days of bidding. */
export const MAX_LOT_INTERVAL_MINUTES = 60;
export const MAX_SALE_DAYS = 30;
export const ANSWER_MAX = 4000;

/** The schedule, interval, premium and handle change only before the sale is scheduled. */
export function isScheduleEditable(sale: Pick<AdminAuctionSale, 'status'>): boolean {
  return sale.status === 'draft';
}

/** Lots join, leave and reorder while the sale is a draft. */
export function canEditLots(sale: Pick<AdminAuctionSale, 'status'>): boolean {
  return sale.status === 'draft';
}

export function canSchedule(sale: Pick<AdminAuctionSale, 'status' | 'lotCount'>): boolean {
  return sale.status === 'draft' && sale.lotCount > 0;
}

export function canCancelSale(sale: Pick<AdminAuctionSale, 'status'>): boolean {
  return sale.status !== 'ended' && sale.status !== 'cancelled';
}

/** A sale with bidding open is polled like a live auction. */
export function salePollInterval(status: AuctionSaleStatus | undefined): number | false {
  return status === 'live' ? 10_000 : false;
}
